import { render, staticRenderFns } from "./PyramidLevelsPerformance.vue?vue&type=template&id=37ff937c&"
import script from "./PyramidLevelsPerformance.vue?vue&type=script&lang=js&"
export * from "./PyramidLevelsPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports